import * as React from 'react';
import InputLabel from '../inputLabel/InputLabel';
import Tooltip from '../tooltip/Tooltip';
import { TooltipPosition } from '../tooltip/TooltipModels';

import * as UI from './style';

interface IInputGroupProps {
  dataAt: string;
  label?: string | React.ReactChild;
  addGap?: number;
  disabled?: boolean;
  className?: string;
  tooltipContent?: string;
  error?: string;
  initErrorSpacing?: boolean;
  dataTestId?: string;
  innerDataTestId?: string;
}

// tslint:disable-next-line:variable-name
const InputGroup: React.FC<IInputGroupProps> = (props) => {
  const [inputGroupHeightElement, setTooltipHeightElement] = React.useState(0);
  const inputGroupWrapNode = React.useRef<HTMLElement>(null);

  const getInputGroupElementHeight = () => {
    if (inputGroupWrapNode && inputGroupWrapNode.current) {
      const { width } = inputGroupWrapNode.current.getBoundingClientRect();
      setTooltipHeightElement(width);
    }
  };

  React.useEffect(() => {
    getInputGroupElementHeight();
  }, []);

  const gapElements = [];
  if (props.addGap) {
    for (let i = 0; i < props.addGap; i++) {
      gapElements.push(<UI.SInputGap key={`gap_${i}`} className="inputInGroup" />);
    }
  }

  return (
    <UI.SInputGroup ref={inputGroupWrapNode} className={props.className} data-testid={props.dataTestId}>
      <UI.SInputGroupTitle>
        {props.label && <InputLabel dataAt={`${props.dataAt}-label`}>{props.label}</InputLabel>}
        {props.tooltipContent && (
          <UI.STooltipWrapper>
            <Tooltip
              position={TooltipPosition.TopRight}
              width={`${inputGroupHeightElement}px`}
              dataAt={`${props.dataAt}-tooltip`}
            >
              {props.tooltipContent}
            </Tooltip>
          </UI.STooltipWrapper>
        )}
      </UI.SInputGroupTitle>
      <UI.SInputGroupInner
        data-at={props.dataAt}
        gaps={props.addGap || 0}
        disabled={props.disabled}
        data-testid={props.innerDataTestId}
      >
        {props.children}
        {gapElements}
      </UI.SInputGroupInner>
      <UI.SErrorMessage
        {...{
          initErrorSpacing: props.initErrorSpacing,
          className: `${props.dataAt}-Error ${!props.error && 'empty'} error-message-container`,
        }}
        data-at={`${props.dataAt}-Error`}
        data-testid={'error-message'}
      >
        {props.error}
      </UI.SErrorMessage>
    </UI.SInputGroup>
  );
};

export default InputGroup;
